var constants = require('../constants');
var api = require('../../../utils/api');
var routerActions = require('react-router-redux').routerActions;
var commonActions = require('../../common/actions/common');

var Newsletter = (function() {

    var _signUpRequest = function() {
        return {
            type: constants.NEWSLETTER_SIGNUP_REQUEST
        };
    }

    var _signUpSuccess = function(data) {
        return {
            type: constants.NEWSLETTER_SIGNUP_SUCCESS,
            data: data,
            meta: {
                analytics: {
                    eventType: constants.NEWSLETTER_SIGNUP_SUCCESS,
                    actionValue: 'signUp',
                    labelValue: 'homepage'
                }
            }
        };
    }

    var _signUpError = function(error) {
        return {
            type: constants.NEWSLETTER_SIGNUP_FAILURE,
            errors: error.data
        };
    }

    var _signUp = function(email) {
        return function(dispatch) {
            dispatch(_signUpRequest());
            api.post('/subscribeproxy', {
                    "email": email
                })
                .then(function(data) {
                    dispatch(_signUpSuccess(data));
                    dispatch(routerActions.push('/education?newsletter=success'));
                })
                .catch(function(error) {
                    if(error.response){
                        if(error.response.data.message === 'Member Exists'){
                            error.response.data.message = 'Email is already subscribed to our newsletter';
                        }else{
                            error.response.data.message = 'Oops! Something went wrong!';
                        }

                        dispatch(_signUpError(error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _clearNewsletterError = function(){
        return {
            type: constants.NEWSLETTER_CLEAR_ERROR,
        }
    }

    return {
        signUp: _signUp,
        clearNewsletterError: _clearNewsletterError
    }
})();

module.exports = Newsletter;



// WEBPACK FOOTER //
// ./src/common/modules/newsletter/actions/newsletter.js